import forEach from 'lodash/forEach'
import uniqueId from 'lodash/uniqueId'

const formatRawMaterialsArray = rawMaterials => {
  const rawMaterialsObject = {}

  forEach(rawMaterials, (rawMaterial, index) => {
    rawMaterialsObject[index] = {
      key: uniqueId('agricultural_input'),
      ...rawMaterial
    }
  })

  return rawMaterialsObject
}

const formatMachinesArray = machines => {
  const machinesObject = {}

  forEach(machines, (machine, index) => {
    machinesObject[index] = {
      key: uniqueId('machine'),
      ...machine
    }
  })

  return machinesObject
}

const RAW_MATERIAL_INITIAL_VALUE = () => ({
  key: uniqueId('agricultural_input'),
  unit: 'Kg'
})

const MACHINE_INITIAL_VALUE = () => ({
  machine_id: uniqueId('machine')
})

export {
  formatMachinesArray,
  formatRawMaterialsArray,
  MACHINE_INITIAL_VALUE,
  RAW_MATERIAL_INITIAL_VALUE
}
